(function () {
    'use strict';

    angular
        .module('rms.common')
        .directive('activityFieldSelect', activityFieldSelect);

    function activityFieldSelect() {
        return {
            restrict: 'E',
            require: 'ngModel',
            controller: activityFieldSelectCtrl,
            controllerAs: 'vm',
            bindToController: true,
            scope: {
                element: '=',
                onChange: '&?'
            },
            templateUrl: 'common/app/components/activities/activity-input/fields/select',
            link: function(scope, elem, attr, ctrl) {
                var vm = scope.vm;
                vm.ngModelCtrl = ctrl;

                ctrl.$render = function() {
                    vm.modelContent = ctrl.$viewValue;
                };
            }
        };
    }

    function activityFieldSelectCtrl(lodash, FbSelectService, GenericModel, $scope, $timeout) {
        var vm = this;
        let plugins = {'remove_button': {}};
        let additionalOptions = {};
        var hasInfiniteScrolling = false;
        var require_search = false;

        this.$onInit = function() {vm.modelContent = null;

            hasInfiniteScrolling = (lodash.get(vm.element, 'options.infinite_scrolling', false) !== false);


            //
            if (hasInfiniteScrolling) {
                const infinite_scrolling_options = vm.element.options.infinite_scrolling;
                //
                const sortBy = lodash.get(infinite_scrolling_options, 'customSortBy', '$order');

                angular.merge(additionalOptions, {
                    maxOptions: lodash.get(infinite_scrolling_options, 'maxOptions', 9999),
                    customSortBy: sortBy,
                    allowSameSearch: true,
                    sortField: {field:sortBy, direction:'asc'},
                    // load: function(e) {
                    //     return loadRemoteData(e);
                    // },
                    // type: function(e) {
                    //     return loadRemoteData(e);
                    // }
                    score: function(search) {
                        return function(item) {
                            return (vm._current_count + 1 - item[sortBy]) / (vm._current_count + 2);
                        };
                    },
                });
                //
                plugins['infinite_scroll'] = infinite_scrolling_options;



            }


            FbSelectService.initTemplateCall(vm.element.options, additionalOptions);


            //
            // if (lodash.has(vm.element, 'datasource.data')) {
            //     setStaticDS();
            //     $scope.$watch(
            //         function() { return vm.element.datasource.data; },
            //         function() { setStaticDS(); }
            //     );
            // } else {
            //     loadRemoteData({
            //         skip: 0,
            //         take: 5
            //     });
            // }
            //
            // if (typeof scope.onChange === typeof function() {}) {
            //     additionalOptions.onChange = scope.onChange;
            // }
            //
            require_search = lodash.get(vm.element, 'options.require_search', false);

            vm.config = angular.merge(
                {
                    create: false,
                    labelField: 'label',
                    valueField: 'value',
                    maxItems: 1,
                    searchField: ['label'],
                    plugins: plugins,
                    options: [],
                    onChange: function(selectedValue) {
                        vm.ngModelCtrl.$setViewValue(selectedValue);
                        handleOnChange(selectedValue);
                    },
                    onInitialize: function(selectize){
                        vm.selectize = selectize;
                        if (!hasInfiniteScrolling) {
                            selectize.onSearchChange('');
                        }
                        // loadRemoteData();
                        // $timeout(function() {
                        //     if (vm.element.attr.disable || vm.pageData.fbData.settings.view_only) {
                        //         vm.selectize.disable();
                        //     }
                        // });
                    },
                    load: function(query, callback) {
                        if (typeof query === typeof "string") {
                            query = { search: query };
                        }
                        if (hasInfiniteScrolling || require_search) {
                            if (!query.search.length) {
                                vm.selectize.clearOptions();
                                // vm.selectize.refreshOptions(false);
                                return callback([]);
                            }
                        }

                        var model = new GenericModel(vm.element.datasource.url);
                        var datasource = vm.element.datasource;
                        if (lodash.has(datasource, 'data')) {
                            return callback(datasource.data);
                        }

                        var method = lodash.get(datasource, 'method', 'get');

                        var params = angular.extend(lodash.get(datasource, 'params', {}), query || {});

                        var request = (method === 'get') ? model[method](params) : model[method]({}, {data:params});
                        delete params['time'];

                        return request.$promise.then(function(res) { //res
                            if (res.success && res.status_code == 200) {
                                if (lodash.has(res, 'selected')) {
                                    vm.modelContent = res.selected;
                                    vm.ngModelCtrl.$setViewValue(res.selected);
                                }

                                if (lodash.has(vm, 'selectize.setTotal') && typeof vm.selectize.setTotal === typeof function() {}) {
                                    vm.selectize.setTotal(res.total);
                                }

                                if (lodash.has(additionalOptions, 'customSortBy')) {
                                    if (!lodash.has(vm, '_current_count')) {
                                        vm._current_count = 0;
                                    }

                                    angular.forEach(res.data, function(_row) {
                                        _row[additionalOptions.customSortBy] = ++vm._current_count;
                                    });
                                }

                                return callback(res.data);
                            } else {
                                console.warn('Calling ' + vm.element.datasource.url + ' fails. Status code: ' + res.status_code); // eslint-disable-line no-console
                                return callback([]);
                            }
                        }, function(res) {
                            console.warn('Calling ' + vm.element.datasource.url + ' fails. Status code: ' + res.status_code); // eslint-disable-line no-console
                            console.warn(res); // eslint-disable-line no-console
                            // return null;
                            return callback([]);
                        });
                    }
                },
                lodash.get(vm.element, 'options.selectize', {}),
                additionalOptions
            );
        }


        function handleOnChange(selectedValue) {
            if (typeof vm.onChange == typeof function() {}) {
                if (selectedValue instanceof Array) {
                    const values = selectedValue.map(function(v) {
                       return lodash.find(vm.ds, { [vm.config.valueField]: v });
                    });
                    callOnChange(vm.element.name, values);
                } else {
                    const value = lodash.find(vm.ds, { [vm.config.valueField]: selectedValue });
                    callOnChange(vm.element.name, value);
                }
            }
        }

        function callOnChange(name, value) {
            $timeout(function() {
                vm.onChange({name: name, value: value });
            });
        }
    }
})();
